<template>
    <div class="flex items-center space-x-2">
        <icon v-if="form.processing" type="spinner" class="text-gray-600 w-4 h-4" />
        <div v-else class="text-gray-700 font-semibold tracking-wide">{{ this.on ? 'Active' : 'Inactive' }}:</div>
        <toggle-input v-model="toggled"></toggle-input>
    </div>

    <error-modal v-model="showModal">
        <div class="space-y-4">
            <h2 class="heading text-center">Uh oh...</h2>
            <p class="text-lg text-gray-800">Something went wrong with your request.</p>
            <p class="text-lg text-gray-800">Please try again later.</p>
        </div>
    </error-modal>
</template>

<script>
import Form from '@/functions/Form'
import ToggleInput from '@/components/shared/ToggleInput'
import Icon from '@/components/shared/Icon'
import ErrorModal from '@/components/shared/ErrorModal'
import emitter from 'tiny-emitter/instance'

export default {
    props: {
        url: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            on: this.active,
            form: Form(),
            showModal: false
        }
    },
    computed: {
        toggled: {
            get() {
                return this.on
            },
            set(value) {
                this.on = value
                let method
                value ? method = 'post' : method = 'delete'
                return this.form.submit(method, this.url, {
                    onSuccess: ({ active, active_until: activeUntil }) => {
                        if(!active) emitter.emit('deactivated', { active })
                        emitter.emit('activated', { active, activeUntil })
                    },
                    onError: (status) => {
                        this.on = !value
                        this.showModal = true
                    }
                })
            }
        },
    },
    components: {
        ToggleInput,
        Icon,
        ErrorModal,
    },
}
</script>
